import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "m-0 grid grid-cols-1 gap-x-4 gap-y-1 sm:grid-cols-2" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", { class: "font-bold uppercase text-gray-500" }, "Fonte", -1)
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", { class: "font-bold uppercase text-gray-500" }, "Horário", -1)
const _hoisted_8 = { class: "m-0" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", { class: "font-bold uppercase text-gray-500" }, "Método", -1)
const _hoisted_11 = { class: "m-0" }
const _hoisted_12 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", { class: "font-bold uppercase text-gray-500" }, "Ranking", -1)
const _hoisted_14 = { class: "m-0" }
const _hoisted_15 = ["data-testid"]

import { computed } from 'vue'

import {
  EFFECTIVE_SOURCE_KIND_LABELS,
  EFFECTIVE_SOURCE_METHOD_PINNED,
  EffectiveSourceKind,
  effectiveSourceMethodLabel
} from '@/constants/ds-attendance.constants'
import type { StationLegKey, StationSourceOrigin } from '@/types/station-evidence.types'
import { formatHourMinuteInOffset } from '@/utils/date'


export default /*#__PURE__*/_defineComponent({
  __name: 'StationSourceOriginSummary',
  props: {
    leg: {},
    source: {},
    at: { default: null },
    timezone: { default: '-03:00' }
  },
  setup(__props: any) {

const props = __props;



const sourceLabel = computed(
  () => props.source.label || EFFECTIVE_SOURCE_KIND_LABELS[props.source.kind] || props.source.kind
)

const timeLabel = computed(() =>
  props.at ? formatHourMinuteInOffset(props.at, props.timezone) : null
)

const methodLabel = computed(() => effectiveSourceMethodLabel(props.source.method))

// `99` é o código da F1 para "fora do ranking configurado na escala" — mostrar
// "99º" seria mentira aritmética; o texto diz o que o número significa. Perna fixada pela
// sobrescrita não venceu pela posição: dizer "1º no ranking" seria outra mentira.
const rankLabel = computed(() => {
  if (props.source.method === EFFECTIVE_SOURCE_METHOD_PINNED) {
    return 'Fixada pela sobrescrita — vale acima do ranking'
  }
  const rank = props.source.rank
  if (rank == null) return null
  return rank === 99 ? 'Fora do ranking da escala' : `${rank}º no ranking aplicável`
})

const EXPLANATIONS: Partial<Record<EffectiveSourceKind, string>> = {
  [EffectiveSourceKind.APP]:
    'Check registrado pelo médico no app, com geolocalização e, quando exigida, biometria.',
  [EffectiveSourceKind.EXTERNAL_APP]:
    'Check importado de um aplicativo externo integrado à escala.',
  [EffectiveSourceKind.SHEET]: 'Linha conciliada e aprovada na folha de presença desta escala.',
  [EffectiveSourceKind.ACTIVITY_RECORD]:
    'Equivalência aprovada em um Registro de Atividade desta vaga.',
  [EffectiveSourceKind.AUTO_PERMANENCE]:
    'Gerada automaticamente pela permanência entre plantões encadeados — não há anexo a exibir.',
  [EffectiveSourceKind.MANUAL_LEGACY]:
    'Check lançado à mão no painel antes da aposentadoria do fluxo manual. Fica no fim do ranking.',
  [EffectiveSourceKind.LEGACY]:
    'Horário herdado da base anterior ao ranking de fontes; não há origem detalhada a abrir.'
}

const explanation = computed(
  () => EXPLANATIONS[props.source.kind] ?? 'Origem sem detalhamento disponível para esta fonte.'
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col gap-2 rounded border border-primary30 bg-primary5 px-3 py-2 text-left text-xs",
    "data-testid": `station-source-origin-summary-${_ctx.leg}`
  }, [
    _createElementVNode("dl", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("dd", {
          class: "m-0",
          "data-testid": `station-source-origin-label-${_ctx.leg}`
        }, _toDisplayString(sourceLabel.value), 9, _hoisted_5)
      ]),
      (timeLabel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("dd", _hoisted_8, _toDisplayString(timeLabel.value), 1)
          ]))
        : _createCommentVNode("", true),
      (methodLabel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("dd", _hoisted_11, _toDisplayString(methodLabel.value), 1)
          ]))
        : _createCommentVNode("", true),
      (rankLabel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("dd", _hoisted_14, _toDisplayString(rankLabel.value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", {
      class: "m-0 text-gray-600",
      "data-testid": `station-source-origin-explanation-${_ctx.leg}`
    }, _toDisplayString(explanation.value), 9, _hoisted_15)
  ], 8, _hoisted_1))
}
}

})